/**
 * Tab label that collapses to a bare icon on small screens.
 *
 * The full labels are too long for a phone-width tab bar, so the icon carries
 * the meaning there and the text takes over from the md breakpoint upwards.
 * Both are always rendered — the swap happens in CSS (.tab-title-* in
 * assets/css/Custom.css), which only hides the text visually, so screen
 * readers still get the real label on every viewport.
 */
const TabTitle = ({ icon, label }) => (
  <span className="tab-title">
    <i className={`uil ${icon} tab-title-icon`} aria-hidden="true" />
    <span className="tab-title-text">{label}</span>
  </span>
);

export default TabTitle;
